import { Eye } from 'react-bytesize-icons';
import layouts from "../../../../assets/images/docs/layouts.png";
import quickswitcher from "../../../../assets/images/docs/quickswitcher.png";
import layoutalign from "../../../../assets/images/docs/layout-align.png";
import split from "../../../../assets/images/docs/layouts/split.png";
import canvas from "../../../../assets/images/docs/layouts/canvas.png";
import minimap from "../../../../assets/images/docs/layouts/minimap.png";
import canvasintro from "../../../../assets/videos/blogs/pp31/canvasintro.mp4";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import * as React from 'react';
export default {
  Eye,
  layouts,
  quickswitcher,
  layoutalign,
  split,
  canvas,
  minimap,
  canvasintro,
  ShortCutDisplay,
  React
};